import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalComponent, Student } from '../../core';

@Component({
  selector: 'lms-student-editor-popup',
  templateUrl: './student-editor-popup.component.html',
  styleUrls: ['./student-editor-popup.component.css']
})
export class StudentEditorPopupComponent implements OnInit, AfterViewInit {
  @ViewChild(ModalComponent, { static: false }) public modal: ModalComponent;

  constructor(public router: Router, public activatedRoute: ActivatedRoute) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.modal.open();
  }
  onSave(student: Student) {
    this.popupClose().then(() => {
      this.goStudent(student);
    });
  }
  popupClose() {
    this.modal.close();
    return this.router.navigate([{ outlets: { popup: null } }]);
  }

  goStudent(student: Student) {
    this.router.navigate(['/students', student.id]);
  }
}
